const getExchangeTypeName = (field, dataType = 'id') => {
	if((dataType === 'id' && field === 1) || (dataType === 'name' && field === 'ForexBuying')) {
		return 'TCMB SATIŞ';
	}
	else if((dataType === 'id' && field === 2) || (dataType === 'name' && field === 'ForexSelling')) {
		return 'TCMB SATIŞ';
	}
	else if((dataType === 'id' && field === 3) || (dataType === 'name' && field === 'BanknoteBuying')) {
		return 'TCMB ALIŞ';
	}
	else if((dataType === 'id' && field === 4) || (dataType === 'name' && field === 'BanknoteSelling')) {
		return 'TCMB Efektif Satış';
	}
	else if ((dataType === 'id' && field === 5) || (dataType === 'name' && field === 'Order')) {
		return 'Ödemeye Özel'
	}
	else if((dataType === 'id' && field === 6) || (dataType === 'name' && field === 'Client')) {
		return 'Müşteri';
	}
	else if((dataType === 'id' && field === 7) || (dataType === 'name' && field === 'Company')) {
		return 'Sistem'
	}
	else {
		return '(' + field + ') ';
	}
}

export default getExchangeTypeName